/**
 * Product
 */

import ProductConfigurables from '../lib/product-configurables';
import productGallery from '../lib/product-gallery';
import productGalleryZoomModal from '../lib/product-gallery-zoom-modal';
import productGalleryCarousel from '../lib/product-gallery-carousel';
import productShare from '../lib/product-share';
import productFramingOptionsDropdown from '../lib/product-framing-options-dropdown';
import estimatedDeliveryDate from '../lib/delivery-estimate';
import whatsIncludedViewer from '../lib/whats-included';
import giftCardActions from '../lib/gift-card-actions';
import productBopis from '../lib/product-bopis';

const $productForm = document.getElementById('addToBagForm');
const $productSection = document.getElementById('product');
const productConfigurables = new ProductConfigurables({
  productForm: $productForm,
  productSection: $productSection,
});
const $productAccordions = [...document.querySelectorAll('.js-pv-acc')];
const { init: initGalleryCarousel } = productGalleryCarousel() || null;

// Product form
productConfigurables.init();

// Gallery
productGallery();

// Gallery Carousel
if (initGalleryCarousel) initGalleryCarousel();

// Gallery Zoom Modal
productGalleryZoomModal();

// Product Share
productShare();

// Product Framing Options Dropdown
productFramingOptionsDropdown();

// Product Delivery Estimate
estimatedDeliveryDate();

// What's Included Viewer
whatsIncludedViewer();

// Gift Card Actions
giftCardActions();

// Product Accordions
if ($productAccordions && $productAccordions.length) {
  $productAccordions.forEach(($productAccordion) => {
    const openOption = __.hasClass($productAccordion.parentElement, 'is-active') ? 0 : null;
    const productAccordion = SDG.accordion({
      dom: {
        id: $productAccordion.id,
      },
      open_option: openOption,
    });
    productAccordion.init();
  });
}

// Product Bopis
productBopis();
